import moment from "moment";
import React, { useState, useEffect } from "react";
import { Line } from "react-chartjs-2";

// import { Row, Col, Card, CardHeader, CardBody, Button } from "shards-react";
import api from "../../api/api";
import { useTranslation } from "react-i18next";
import { getSensorDepths } from "../../utils/sensorDepths";

const SubSoil = ({ data, codeSensor, sensorDepths }) => {
  const { t, i18n } = useTranslation();
  const depths = getSensorDepths(sensorDepths);

  const addDays = (date, days) => {
    let result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  };

  const [historyData, setHistoryData] = useState([]);
  const [dateValue, setDateValue] = useState({
    dateStart: new Date(),
    dateEnd: new Date(),
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  useEffect(() => {
    const getHistorySensor = async (page) => {
      await api
        .get(
          `/sensor/sensor-history/${codeSensor}/${addDays(dateValue.dateStart, -7)}/${dateValue.dateEnd}?pageNum=1&limit=28`,
        )
        .then((response) => {
          let historyResult = response.data.history;
          let sensorCoords = response.data.sensor_id;
          setHistoryData(historyResult);
          setCurrentPage(page);
          setTotalPages(response.data.totalPages);
        })
        .catch((err) => {
          console.log(err);
        });
    };
    getHistorySensor();
  }, [codeSensor]);

  const [state, setState] = useState(null);

  const getChartData = () => {
    const historyDataCopy = [...historyData];

    const dataMv1 = [];
    const dataMv2 = [];
    const dataMv3 = [];
    const labels = [];
    historyDataCopy.sort((a, b) => {
      const timeA =
        a.timestamp_arduino !== null && a.timestamp_arduino !== "null"
          ? a.timestamp_arduino
          : a.time;
      const timeB =
        b.timestamp_arduino !== null && b.timestamp_arduino !== "null"
          ? b.timestamp_arduino
          : b.time;
      return moment(timeA).valueOf() - moment(timeB).valueOf();
    });
    historyDataCopy.forEach((sensorData) => {
      const timeToUse =
        sensorData.timestamp_arduino !== null &&
        sensorData.timestamp_arduino !== "null"
          ? sensorData.timestamp_arduino
          : sensorData.time;

      const dateTime = moment(timeToUse);
      const formattedDateTime = dateTime.format("MMM Do HH:mm"); // format date as "MMM Do HH:mm"
      const mv1 = parseFloat(sensorData.mv1);
      const mv2 = parseFloat(sensorData.mv2);
      const mv3 = parseFloat(sensorData.mv3);

      labels.push(formattedDateTime);
      dataMv1.push(mv1);
      dataMv2.push(mv2);
      dataMv3.push(mv3);
    });

    // sort labels in ascending order
    // labels.sort((a, b) => {
    //   const timestampA = moment(a, 'MMM Do HH:mm').valueOf();
    //   const timestampB = moment(b, 'MMM Do HH:mm').valueOf();
    //   return timestampA - timestampB;
    // });

    const state = {
      labels: labels,
      datasets: [
        {
          label: `${t("Humidity")} ${depths.mv1} cm`,
          lineTension: 0.2,
          borderWidth: 2,
          data: dataMv1,
          fill: false,
          backgroundColor: [
            "rgba(75,192,192,0.2)",
            "rgba(75,192,192,0.4)",
            "rgba(75,192,192,0.6)",
          ],
          borderColor: "#FC5566",
        },
        {
          label: `${t("Humidity")} ${depths.mv2} cm`,
          lineTension: 0.2,
          borderWidth: 2,
          data: dataMv2,
          fill: false,
          backgroundColor: [
            "rgba(75,192,192,0.2)",
            "rgba(75,192,192,0.4)",
            "rgba(75,192,192,0.6)",
          ],
          borderColor: "#3CB371",
        },
        {
          label: `${t("Humidity")} ${depths.mv3} cm`,
          lineTension: 0.2,
          borderWidth: 2,
          data: dataMv3,
          fill: false,
          backgroundColor: [
            "rgba(75,192,192,0.2)",
            "rgba(75,192,192,0.4)",
            "rgba(75,192,192,0.6)",
          ],
          borderColor: "#1E90FF",
        },
      ],
    };

    setState(state);
  };

  useEffect(() => {
    getChartData();
  }, [historyData, depths.mv1, depths.mv2, depths.mv3]);

  const options = {
    plugins: {
      title: {
        display: false,
        text: "Subsoil Humidity (%)",
        font: {
          size: 15,
        },
      },
      legend: {
        display: true,
        position: "bottom",
        labels: {
          font: {
            size: 10,
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        min: 0,
        max: 100,
        ticks: {
          stepSize: 25,
          color: "#000",
          font: {
            size: 14,
          },
        },
        grid: {
          color: "rgba(0,0,0,0.2)",
          lineWidth: 1,
        },
      },
      x: {
        ticks: {
          autoSkip: false,
          maxRotation: 90,
          color: "#000",
          font: {
            size: 10,
          },
        },
        grid: {
          color: "rgba(0,0,0,0.2)",
          lineWidth: 1,
        },
      },
    },
  };

  const hasData = state && state.labels && state.labels.length > 0;

  return (
    <div>
      {hasData ? (
        <Line
          data={state}
          options={options}
          height={263}
          style={{ height: "100%", width: "80%", margin: "0 auto" }}
        />
      ) : (
        <p className="text-center text-muted p-4">
          {t("no_data", { defaultValue: "No sensor history found for this period." })}
        </p>
      )}
    </div>
  );
};

export default SubSoil;
